import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { isAuthenticated } from '../../utils/auth';
import { setIsDirty } from '../../features/upload/uploadSlice';

const ProtectedRoute: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const currentPath = location.pathname;

    const isEditablePage =
      currentPath === "/processing" ||
      currentPath.startsWith("/draft-meeting/");

    if (!isEditablePage) {
      dispatch(setIsDirty(false));
    }
  }, [location.pathname, dispatch]);

  const loggedIn = isAuthenticated();
  const consentGiven = localStorage.getItem("uploadConsent") === "true";

  if (!loggedIn) {
    return <Navigate to="/" replace />;
  }

  const restrictedPaths = ["/upload", "/processing"];

  if (!consentGiven && restrictedPaths.includes(location.pathname)) {
    return <Navigate to="/afterLogin" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;